/*
 * version:v1.0.0
 * date:2017-2
 * desc:所有站点可配置验证码
 * uthor: tht
*/

/*---------------update by ligen at 2017-8-24 --------------*/
/*
 * version:v1.1.0
 * date:2017-8
 * desc:修改了验证码类型及验证码生成接口的获取途径，由原来的接口改为静态js加载
 * uthor：ligen
*/
; (function () {
    //可配置验证码构造函数
    function ConfigCaptcha(Defaults) {

        //简单验证码html
        var simHtml = '<p>' +
            '<label>验证码：</label>' +
            '<input type="text" value="" name="js_configCaptchaValue" />' +
            '<input type="hidden" name="js_cookieCaptchaValue"/>' +
            '<img src="" class="js_configCaptchaImg js_refreshConfigCaptcha" />' +
            '<a class="js_refreshConfigCaptcha">看不清？</a>' +
            '</p>';

        //复杂验证码html
        var comHtml = '<div class="configCaptchaCom">' +
            '<p class="configCaptchaContainer_p01">' +
            '<label class="configCaptcha_text">验证码：</label>' +
            '<span class="configCaptchaInput_container">' +
            '<em class="configCaptchaInput js_configCaptchaInput"><i class="configCaptchaImg js_configCaptchaImg"></i></em>' +
            '<em class="configCaptchaInput js_configCaptchaInput"><i class="configCaptchaImg js_configCaptchaImg"></i></em>' +
            '<em class="configCaptchaInput js_configCaptchaInput"><i class="configCaptchaImg js_configCaptchaImg"></i></em>' +
            '<em class="configCaptchaInput js_configCaptchaInput"><i class="configCaptchaImg js_configCaptchaImg"></i></em>' +
            '<em class="configCaptchaIcon configCaptchaInput configCaptcha_DeleteBtn js_deleteConfigCaptcha"></em>' +
            '</span>' +
            '<i class="configCaptchaIcon configCaptcha_Tip02 js_checkChinaCaptchaTip default"></i>' +
            '</p>' +
            '<p class="configCaptchaContainer_p02">' +
            '<span class="configCaptchaImg js_configCaptchaImg configCaptchaImg_yes js_refreshConfigCaptcha"></span>' +
            '<a class="configCaptchaChange js_refreshConfigCaptcha">看不清？</a>' +
            '</p>' +
            '<p class="configCaptchaContainer_p03">点击框内文字输入上图中<b class="configCaptcha_Tip03">汉字</b>相应文字</p>' +
            '<div class="configCaptchaContainer_p04">' +
            '<ul class="configCaptchaSelectCon js_ChinaCaptchaSelect">' +
            '<li id="gy_captcha_item_0" class="configCaptchaImg js_configCaptchaImg configCaptchaImg_0 js_captchaCaptchaSelect_img" data-code="0"></li>' +
            '<li id="gy_captcha_item_1" class="configCaptchaImg js_configCaptchaImg configCaptchaImg_1 js_captchaCaptchaSelect_img" data-code="1"></li>' +
            '<li id="gy_captcha_item_2" class="configCaptchaImg js_configCaptchaImg configCaptchaImg_2 js_captchaCaptchaSelect_img" data-code="2"></li>' +
            '<li id="gy_captcha_item_3" class="configCaptchaImg js_configCaptchaImg configCaptchaImg_3 js_captchaCaptchaSelect_img" data-code="3"></li>' +
            '<li id="gy_captcha_item_4" class="configCaptchaImg js_configCaptchaImg configCaptchaImg_4 js_captchaCaptchaSelect_img" data-code="4"></li>' +
            '<li id="gy_captcha_item_5" class="configCaptchaImg js_configCaptchaImg configCaptchaImg_5 js_captchaCaptchaSelect_img" data-code="5"></li>' +
            '<li id="gy_captcha_item_6" class="configCaptchaImg js_configCaptchaImg configCaptchaImg_6 js_captchaCaptchaSelect_img" data-code="6"></li>' +
            '<li id="gy_captcha_item_7" class="configCaptchaImg js_configCaptchaImg configCaptchaImg_7 js_captchaCaptchaSelect_img" data-code="7"></li>' +
            '<li id="gy_captcha_item_8" class="configCaptchaImg js_configCaptchaImg configCaptchaImg_8 js_captchaCaptchaSelect_img" data-code="8"></li>' +
            '</ul>' +
            '</div>' +
            '</div> ';
        this.Defaults = {     //默认参数
            isOpenCaptchaUrl: "//qibao.tjlong.cn/login/NeedCaptcha",//是否需要验证码登录
            cssLinkSrc: "//g.tjlong.cn/qibao/Lib/css/configCaptcha.min.css", //自定义验证码样式
            loadScriptSrc: "//validation.gyyx.cn/captcha-route.js?r=",//自定义获取js
            data: {           //参数
                bid: ""  //区分不同业务 默认为空
            },
            simHtml: simHtml, //简单验证码元素 自定义形式：1、jquery对象，2、字符串
            comHtml: comHtml, //复杂验证码元素  自定义形式：1、jquery对象，2、字符串
            inputName: "js_configCaptchaValue",  //自定义隐藏域name名称
            inputCookieName: "js_cookieCaptchaValue",//自定义隐藏域cookie name名称
            inputaccName: "account",//自定义账号name名称(失去焦点时验证是否需要验证码)
            popDefaultTip: "请输入验证码完成登录", //弹层顶部默认提示语
            popErrorTip: "验证码输入错误", //弹层顶部后接口返回验证码错误提示语
            popWidth: "340px", //弹层宽度
            popHeight: "430px", //弹层高度
            flexStatus: false, //弹性布局开关  需要配合cssLinkSrc参数，使用弹性样式
            comIn: false,       //复杂验证码是否内嵌 true:内嵌  false：弹层 
            typeIsOnlyCom: false, //验证码类型是否只是复杂类型：true:只有复杂类型（无需接口判断验证码类型）；false：验证码类型可配（需要接口判断验证码类型）
            captchaInWrap: "#configCaptchaWrap",  //内嵌验证码容器（简单，复杂）
            isOpenCaptcha: false,//是否需要验证码开关(部分业务需求需要开启 如：登录)
            subFn: function () { },        //弹层提交按钮执行函数（同一窗口有多个业务是弹层复杂验证码，在弹层打开函数中传入）
            closeFn: function () { },  //弹层关闭按钮执行函数（同一窗口有多个业务时弹层复杂验证码，在弹层打开函数中传入）
            errorTipFn: function (wrap) {  //内嵌复杂验证码错误提示
                wrap.find(".js_checkChinaCaptchaTip").addClass("error");
            },
            succTipFn: function (wrap) {   //内嵌复杂验证码正确提示
                wrap.find(".js_checkChinaCaptchaTip").removeClass("error").addClass("success");
            },
            initError: function () {   //验证码初始化失败
                alert("验证码初始化失败！");
            },
            aliyunAppkey:"FFFF0N0000000000710C", //滑动验证码专用
            aliyunScene:"nc_login", //滑动验证码pc端专用scene
            aliyunMobileScene:"nc_login_h5", //滑动验证码移动端专用scene
            NC_Opt :{
                renderTo: "#js_slider_captcha",
                appkey: "aliyunAppkey",
                scene: "nc_login",
                token: "nc_token",
                customWidth: 357,//接入滑动验证码的长度
                trans:{"key1":"code0"},
                elementID: ["usernameID"],
                is_Opt: 0,
                language: "cn",
                isEnabled: true,
                timeout: 3000,
                times:5,
                apimap: {
                    // 'analyze': '//a.com/nocaptcha/analyze.jsonp',
                    // 'get_captcha': '//b.com/get_captcha/ver3',
                    // 'get_captcha': '//pin3.aliyun.com/get_captcha/ver3'
                    // 'get_img': '//c.com/get_img',
                    // 'checkcode': '//d.com/captcha/checkcode.jsonp',
                    // 'umid_Url': '//e.com/security/umscript/3.2.1/um.js',
                    // 'uab_Url': '//aeu.alicdn.com/js/uac/909.js',
                    // 'umid_serUrl': 'https://g.com/service/um.json'
                },   
                callback: function (data) { 

                }
            },
            isLoadNcScript: false,
            isSlideNcType:false,
            isLoadNcScript: false, //阿里验证码判断标识
            isSlideNcType: false, //阿里验证码判断标识
            tenyunAppId:"2075382095",//腾讯云滑动验证码appId
            isLoadTencentScript: false, //腾讯验证码判断标识
            isSlideTencentType: false, //腾讯验证码判断标识
        };

        //IE6下默认不缓存背景图片，CSS里每次更改图片的位置时都会重新发起请求，用这个方法告诉IE6缓存背景图片 
        var isIE6 = /msie 6/i.test(navigator.userAgent);
        if (isIE6) {
            try { document.execCommand('BackgroundImageCache', false, true); } catch (e) { }
        }

        //不传bid时，使用默认值
        if (Defaults && Defaults.data && !Defaults.data.bid) {

            $.extend(Defaults.data, this.Defaults.data);
        }

        $.extend(this.Defaults, Defaults);  //扩展参数

    }

    ConfigCaptcha.prototype = {

        //主程序入口
        init: function (confData) {
            var _this = this;
            if (this.Defaults.isOpenCaptcha) {
                var sUserName = $("input[name=" + _this.Defaults.inputaccName + "]").val();
                $("input[name=" + _this.Defaults.inputaccName + "]").unbind('change').bind('change', function () {
                    var sUserName = $("input[name=" + _this.Defaults.inputaccName + "]").val();
                    _this.isNeedCaptcha(confData, sUserName);
                });
                _this.isNeedCaptcha(confData, sUserName);
            } else {
                this.isNeedCaptcha(confData);
            }
        },
        //获取动态js验证码数据
        loadScript: function (url, callback) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            if (typeof (callback) != "undefined") {
                if (script.readyState) {
                    script.onreadystatechange = function () {
                        if (script.readyState == "loaded" || script.readyState == "complete") {
                            script.onreadystatechange = null;
                            callback();
                        }
                    };
                } else {
                    script.onload = function () {
                        callback();
                    };
                }
            }
            script.src = url;
            var head = document.getElementsByTagName("head")[0];
            head.appendChild(script);
        },
        //新验证码的修改通过接口先获取到cookie值，然后通过获取到的cookie值生成image图片
        AjaxCookiesImgUrl: function (callback) {
            var _this = this;
            $.ajax({
                url: "//" + _this.gy_url + "/captcha/id?bid=" + _this.Defaults.data.bid,
                callback: "callback",
                dataType: "jsonp",
                type: "GET",
                success: function (data) {
                    if (data.isSuccess) {
                        var url = "//"+_this.gy_url + "/captcha/image?bid=" + _this.Defaults.data.bid + "&cid=" + data.data;
                        //直接对取到的cookie赋值到隐藏域
                        $(_this.Defaults.captchaInWrap).find("input[name='" + _this.Defaults.inputCookieName + "']").attr("value", data.data);
                        //url为生成的验证码图片
                        callback(url)
                    }

                }

            })

        },

        //是否需要验证码
        isNeedCaptcha: function (confData, sUserName) {
            var _this = this;

            var datas = {
                r: Math.random()
            };
            $.extend(datas, _this.Defaults.data);  //组合参数 bid
            if (confData && confData instanceof Object) {
                $.extend(datas, confData);  //组合业务专有参数
            }
            var configCaptchaWrap = $(_this.Defaults.captchaInWrap); //页面中内嵌验证码容器（简单或复杂）
            this.loadScript(_this.Defaults.loadScriptSrc + Math.random(), function () { //加载,并执行回调函数
                if (callback_captcha[datas.bid] == undefined) {
                    alert("没有找到对应的bid值，请到配置中心确认")
                } else {
                    if(callback_captcha[datas.bid].type=='gyyx'){
                            _this.gy_url = callback_captcha[datas.bid].gy_url.split("/")[2];
                        if (_this.Defaults.typeIsOnlyCom) {  //无loadScript需判断验证码类型，只有复杂验证码
                            //设置验证码类型
                            if (_this.Defaults.isOpenCaptcha) {
                                $.ajax({
                                    url: _this.Defaults.isOpenCaptchaUrl,
                                    type: "GET",
                                    dataType: "jsonp",
                                    jsonp: "jsoncallback",
                                    data: {
                                        bid: _this.bid,
                                        r: Math.random(),
                                        account: sUserName
                                    },
                                    success: function (data) {
                                        if (data && data.need == "1") {
                                            _this.captcahSwitchOpen = 1;
                                        } else {
                                            _this.captcahSwitchOpen = -1;
                                        }
                                    }
                                });
                            } else {
                                _this.captcahSwitchOpen = 1;
                            }
                            _this.comCaptchaInitFn(configCaptchaWrap); //复杂验证码初始化

                        }
                        else {//验证码类型可配置，三种类型：-1：无验证码；0：简单验证码；1：复杂验证码       接入了阿里云滑动验证码  edit by 2019/01/15
                            var captchaDataType = callback_captcha[datas.bid].gy_kind
                            // 设置验证码类型
                            if (_this.Defaults.isOpenCaptcha) {
                                $.ajax({
                                    url: _this.Defaults.isOpenCaptchaUrl,
                                    type: "GET",
                                    dataType: "json",
                                    jsonp: "jsoncallback",
                                    data: {
                                        bid: _this.bid,
                                        r: Math.random()
                                    },
                                    success: function (data) {
                                        if (data && data.need == "1" && !data.isShowAliNeedCaptcha) {
                                            _this.captcahSwitchOpen = parseInt(captchaDataType);
                                        }else if(data && data.need == "1" && data.isShowAliNeedCaptcha){
                                            if($(_this.Defaults.captchaInWrap).attr("id")) {
                                                $(_this.Defaults.captchaInWrap).addClass("nc-container");
                                                _this.Defaults.captchaInWrap = "#"+$(_this.Defaults.captchaInWrap).attr("id");
                                            }else{
                                                $(_this.Defaults.captchaInWrap).attr("id","js_slider_captcha");
                                                $(_this.Defaults.captchaInWrap).addClass("nc-container");
                                                _this.Defaults.captchaInWrap = "#js_slider_captcha";
                                            }
                                            _this.captcahSwitchOpen = 0;
                                            _this.Defaults.isSlideNcType = true;
                                        } else {
                                            _this.captcahSwitchOpen = -1;
                                        }
                                        switch (_this.captcahSwitchOpen) {
                                            case -1://无验证码
                                                configCaptchaWrap.html('<input type="hidden" name="js_configCaptchaValue"/>');  //清空验证码容器，添加验证码隐藏域
                                                break;
                                            case 0://简单验证码   接入了滑动验证码
                                            if (_this.Defaults.isSlideNcType) {
                                                if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) { 
                                                    if (!_this.Defaults.isLoadNcScript) {
                                                        _this.loadScript("//g.alicdn.com/sd/nch5/index.js?t=" + Math.random(), function () {
                                                            _this.Defaults.isLoadNcScript = true;
                                                            _this.slideCaptchaInMobileFn(_this.Defaults.captchaInWrap);
                                                        })
                                                    } else {
                                                        _this.slideCaptchaInMobileFn(_this.Defaults.captchaInWrap);
                                                    }
                                                    _this.closeCaptchaPop();
                                                }else{
                                                    //pc端
                                                    if (!_this.Defaults.isLoadNcScript) {
                                                        _this.loadScript("//g.alicdn.com/sd/ncpc/nc.js?t=" + Math.random(), function () {
                                                            _this.Defaults.isLoadNcScript = true;
                                                            _this.slideCaptchaFn(_this.Defaults.captchaInWrap, _this.Defaults.customWidth);
                                                        })
                                                    } else {
                                                        _this.slideCaptchaFn(_this.Defaults.captchaInWrap, _this.Defaults.customWidth);
                                                    }
                                                    _this.closeCaptchaPop();

                                                }
                                            }else{
                                                _this.insertCaptchaHtmlFn(configCaptchaWrap, _this.Defaults.simHtml); //插入简单验证码html
                                                _this.AjaxCookiesImgUrl(function (data) {
                                                    var srcs = data + "&r=" + Math.random();  //简单验证码图片
                                                    configCaptchaWrap.find(".js_configCaptchaImg").attr("src", srcs);

                                                });
                                                _this.refreshCaptchaEvent(configCaptchaWrap);
                                            }
                                                break;
                                            case 1://需要复杂验证码

                                                _this.comCaptchaInitFn(configCaptchaWrap); //复杂验证码初始化
                                                break;
                                            default:
                                                _this.initError();
                                                break;
                                        }
                                        _this.replaceInputNameFn();  //替换自定义input的name名称
                                        _this.replaceInputCookieNameFn(); //替换自定义cookie input的name名称

                                        //_this.getCookieFn();//获取当前验证码cookie值

                                    }
                                });
                            } else {
                                _this.captcahSwitchOpen = parseInt(captchaDataType);
                                switch (_this.captcahSwitchOpen) {
                                    case -1://无验证码
                                        configCaptchaWrap.html('<input type="hidden" name="js_configCaptchaValue"/>');  //清空验证码容器，添加验证码隐藏域
                                        break;
                                    case 0://简单验证码
                                        _this.insertCaptchaHtmlFn(configCaptchaWrap, _this.Defaults.simHtml); //插入简单验证码html                                    
                                        _this.AjaxCookiesImgUrl(function (data) {
                                            var srcs = data + "&r=" + Math.random();  //简单验证码图片
                                            configCaptchaWrap.find(".js_configCaptchaImg").attr("src", srcs);

                                        });

                                        _this.refreshCaptchaEvent(configCaptchaWrap);

                                        break;
                                    case 1://需要复杂验证码

                                        _this.comCaptchaInitFn(configCaptchaWrap); //复杂验证码初始化

                                        break;
                                    default:
                                        _this.initError();
                                        break;
                                }
                                _this.replaceInputNameFn();  //替换自定义input的name名称
                                _this.replaceInputCookieNameFn(); //替换自定义cookie input的name名称

                                //_this.getCookieFn();//获取当前验证码cookie值

                            }
                        }

                    }else if(callback_captcha[datas.bid].type=='aliyun'){                       
                        //验证码类型可配置，三种类型：-1：无验证码；0：简单验证码；1：复杂验证码       接入了阿里云滑动验证码  edit by 2019/01/15
                            var captchaDataType = callback_captcha[datas.bid].gy_kind;

                            // 设置验证码类型    
                                    if($(_this.Defaults.captchaInWrap).attr("id")) {
                                        $(_this.Defaults.captchaInWrap).addClass("nc-container");
                                        _this.Defaults.captchaInWrap = "#"+$(_this.Defaults.captchaInWrap).attr("id");
                                    }else{
                                        $(_this.Defaults.captchaInWrap).attr("id","js_slider_captcha");
                                        $(_this.Defaults.captchaInWrap).addClass("nc-container");
                                        _this.Defaults.captchaInWrap = "#js_slider_captcha";
                                    }
                                    _this.captcahSwitchOpen = 0;
                                    _this.Defaults.isSlideNcType = true;
                                    
                                switch (_this.captcahSwitchOpen) {
                                    case 0://简单验证码   接入了滑动验证码
                                    if (_this.Defaults.isSlideNcType) {
                                        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) { 
                                            if (!_this.Defaults.isLoadNcScript) {
                                                _this.loadScript("//g.alicdn.com/sd/nch5/index.js?t=" + Math.random(), function () {
                                                    _this.Defaults.isLoadNcScript = true;
                                                    _this.slideCaptchaInMobileFn(_this.Defaults.captchaInWrap);
                                                })
                                            } else {
                                                _this.slideCaptchaInMobileFn(_this.Defaults.captchaInWrap);
                                            }
                                            _this.closeCaptchaPop();
                                        }else{
                                            //pc端
                                            if (!_this.Defaults.isLoadNcScript) {
                                                _this.loadScript("//g.alicdn.com/sd/ncpc/nc.js?t=" + Math.random(), function () {
                                                    _this.Defaults.isLoadNcScript = true;
                                                    _this.slideCaptchaFn(_this.Defaults.captchaInWrap, _this.Defaults.customWidth);
                                                })
                                            } else {
                                                _this.slideCaptchaFn(_this.Defaults.captchaInWrap, _this.Defaults.customWidth);
                                            }
                                            _this.closeCaptchaPop();

                                        }
                                    }
                                        break;
                                    
                                    default:
                                        _this.initError();
                                        break;
                                }
                                _this.replaceInputNameFn();  //替换自定义input的name名称
                                _this.replaceInputCookieNameFn(); //替换自定义cookie input的name名称

                                //_this.getCookieFn();//获取当前验证码cookie值
                    }else if (callback_captcha[datas.bid].type == 'tenyun') { //接入腾讯云验证码 
                        _this.captcahSwitchOpen = 3;
                        _this.Defaults.isSlideTencentType = true;
                            if (_this.Defaults.isSlideTencentType) {
                                if (!_this.Defaults.isLoadTencentScript) {
                                    _this.loadScript("https://turing.captcha.qcloud.com/TCaptcha.js?t=" + Math.random(), function () {
                                        _this.Defaults.isLoadTencentScript = true;                                    
                                    })
                                }
                            }
                        _this.replaceInputNameFn(); //替换自定义input的name名称
                        _this.replaceInputCookieNameFn(); //替换自定义cookie input的name名称

                        //_this.getCookieFn();//获取当前验证码cookie值
                    }
                }

            });
        },
        //复杂验证码初始化
        comCaptchaInitFn: function (wrap) {
            var _this = this;
            //引入中文验证码样式
            if (!document.getElementById("configCaptchaLink")) {  //不重复引入样式表

                $("head").append('<link href="' + _this.Defaults.cssLinkSrc + '" rel="stylesheet" type="text/css" id="configCaptchaLink">'); //引入样式
            }

            if (_this.Defaults.comIn) {  //内嵌形式

                _this.insertCaptchaHtmlFn(wrap, _this.Defaults.comHtml); //插入复杂验证码html
                wrap.append('<input type="hidden" name="js_configCaptchaValue"/>' +
                            '<input type="hidden" name="js_cookieCaptchaValue"/>');
                _this.addEventForCaptcha();

            } else {
                wrap.html('<input type="hidden" name="js_configCaptchaValue"/>' +
                          '<input type="hidden" name="js_cookieCaptchaValue"/>');  //清空验证码容器，添加验证码隐藏域
                _this.createCaptchaPop();
            }
        },
        //添加嵌入式验证码html元素
        insertCaptchaHtmlFn: function (wrap, innerHtml) {
            var _this = this;
            if (typeof innerHtml === "string") {
                wrap.html(innerHtml); //内嵌验证码元素
            } else if (innerHtml instanceof $) { //以id形式传入jquery对象
                innerHtml = innerHtml.clone().removeAttr("id").show(); //复制页面中自定义验证码元素，移除副本id,将副本设置可见
                wrap.html(innerHtml);
            } else {
                alert("传入的验证码html元素无效");
            }
        },
        /**
         * @name slideCaptchaFn
         * @desc 接入阿里云滑动验证码
         */
        slideCaptchaFn:function(dom,width){
            var _this = this;
            var nc_token = [_this.Defaults.aliyunAppkey, (new Date()).getTime(), Math.random()].join(':');
            _this.Defaults.NC_Opt.renderTo = dom;
            _this.Defaults.NC_Opt.appkey = _this.Defaults.aliyunAppkey;
            _this.Defaults.NC_Opt.token = nc_token;
            _this.Defaults.NC_Opt.scene = _this.Defaults.aliyunScene;
             _this.Defaults.NC_Opt.customWidth =  width;
            _this.Defaults.NC_Opt.callback = function (data) {
                var jsonStr = '{"SessionId":"' + data.csessionid + '","Sig":"' + data.sig + '","Token":"' + nc.getToken() + '","Scene":"' + _this.Defaults.aliyunScene + '","AppKey":"'+_this.Defaults.aliyunAppkey+'"}';
                $("input[name=cookies]").remove();
                $(_this.Defaults.captchaInWrap).append('<input type="hidden" name="cookies"  value="' + jsonStr.replace(/\"/g, "&quot;") + '"/>');
                $("input[name=cookieslogin]").remove();
                $(_this.Defaults.captchaInWrap).append('<input type="hidden" name="cookieslogin"  value="' + jsonStr.replace(/\"/g, "&quot;") + '"/>');


            }
            nc = new noCaptcha(_this.Defaults.NC_Opt)
            nc.upLang('cn', {
                _startTEXT: "请按住滑块，拖动到最右边",
                _yesTEXT: "验证通过",
                _error300: "哎呀，出错了，点击<a href=\"javascript:__nc.reset()\">刷新</a>再来一次",
                _errorNetwork: "网络不给力，请<a href=\"javascript:__nc.reset()\">点击刷新</a>"
            })
        },
         /**
         * @name slideCaptchaInMobileFn
         * @desc 接入阿里云移动端滑动验证码
         */
        slideCaptchaInMobileFn:function(dom){
            var _this = this;
            var nc_token = [_this.Defaults.aliyunAppkey, (new Date()).getTime(), Math.random()].join(':');
            nc_mobile = NoCaptcha.init({
                renderTo: dom,
                appkey: _this.Defaults.aliyunAppkey,
                scene: _this.Defaults.aliyunMobileScene,
                token: nc_token,
                trans: { "key1": "code0" },
                elementID: ["usernameID"],
                is_Opt: 0,
                language: "cn",
                timeout: 10000,
                retryTimes: 5,
                errorTimes: 5,
                inline: false,
                apimap: {},
                bannerHidden: false,
                initHidden: false,
                callback: function (data) {
                    var jsonStr = '{"SessionId":"' + data.csessionid + '","Sig":"' + data.sig + '","Token":"' + nc_token + '","Scene":"' + _this.Defaults.aliyunMobileScene + '","AppKey":"'+_this.Defaults.aliyunAppkey+'"}';
                    $("input[name=cookies]").remove();
                    $(_this.Defaults.captchaInWrap).append('<input type="hidden" name="cookies"  value="' + jsonStr.replace(/\"/g, "&quot;") + '"/>');
                    $("input[name=cookieslogin]").remove();
                    $(_this.Defaults.captchaInWrap).append('<input type="hidden" name="cookieslogin"  value="' + jsonStr.replace(/\"/g, "&quot;") + '"/>');

                },
                error: function (s) {
                }
            });
            NoCaptcha.setEnabled(true);
            nc_mobile.reset();//请务必确保这里调用一次reset()方法
            NoCaptcha.upLang('cn', {
                'LOADING': "加载中...",//加载
                'SLIDER_LABEL': "请向右滑动验证",//等待滑动
                'CHECK_Y': "验证通过",//通过
                'ERROR_TITLE': "非常抱歉，这出错了...",//拦截
                'CHECK_N': "验证未通过", //准备唤醒二次验证
                'OVERLAY_INFORM': "经检测你当前操作环境存在风险，请输入验证码",//二次验证
                'TIPS_TITLE': "验证码错误，请重新输入"//验证码输错时的提示
            });

        },
        //替换隐藏域name名称
        replaceInputNameFn: function () {
            var _this = this;
            if (_this.Defaults.inputName) {
                $(_this.Defaults.captchaInWrap).find("input[name='js_configCaptchaValue']").attr("name", _this.Defaults.inputName);
            } else {
                _this.Defaults.inputName = "js_configCaptchaValue";
            }

        },
        //替换隐藏域cookie name名称
        replaceInputCookieNameFn: function () {
            var _this = this;
            if (_this.Defaults.inputCookieName) {
                $(_this.Defaults.captchaInWrap).find("input[name='js_cookieCaptchaValue']").attr("name", _this.Defaults.inputCookieName);
            } else {
                _this.Defaults.inputName = "js_cookieCaptchaValue";
            }

        },
        //获取指定cookie值
        //getCookieFn: function (cookieName) {
        //    var _this = this;
        //    var strCookie = document.cookie;
        //    var arrCookie = strCookie.split("; ");
        //    for (var i = 0; i < arrCookie.length; i++) {
        //        var arr = arrCookie[i].split("=");
        //        if (cookieName == arr[0]) {
        //            return $(_this.Defaults.captchaInWrap).find("input[name='" + _this.Defaults.inputCookieName + "']").attr("value", arr[1]);
        //        }
        //    }
        //    return "";
        //},
        //生成验证码弹出层
        createCaptchaPop: function () {
            var _this = this;
            var popSizeUnit = "";
            //创建元素

            var outWrap = document.createElement("div");
            var wrap = document.createElement("div");

            var title = document.createElement("h3");
            var close = document.createElement("a");

            var tip = document.createElement("p");
            var callBackErrorTip = document.createElement("p");

            var pop = document.createElement("div");

            var btnWrap = document.createElement("p");
            var btn = document.createElement("span");

            var mask = document.createElement("div");

            //添加class
            outWrap.className = "configCaptchaPopOutWrap js_configCaptchaPop";
            wrap.className = "configCaptchaPopWrap";

            title.className = "configCaptcha_Title";
            close.className = "configCaptchaIcon configCaptcha_close js_configCaptcha_close";

            tip.className = "configCaptcha_Tip01 js_defaultTextTips";
            callBackErrorTip.className = "configCaptcha_Tip01_error js_errorTextTips";

            pop.className = "configCaptchaPop js_configCaptchaPopIn";

            btnWrap.className = "configCaptchaContainer_p05";
            btn.className = "configCaptchaSubmit_Btn js_chinaCaptchaBtn";
            btn.id = "btn_login_captcha_submit";
            mask.className = "configCaptchaMask";

            //计算弹层位置
            if (_this.Defaults.flexStatus) {
                popSizeUnit = "rem";
            } else {
                popSizeUnit = "px";
            }
            wrap.style.width = parseFloat(_this.Defaults.popWidth) + popSizeUnit;
            wrap.style.height = parseFloat(_this.Defaults.popHeight) + popSizeUnit;

            wrap.style.marginLeft = -parseFloat(_this.Defaults.popWidth) / 2 + popSizeUnit;
            wrap.style.marginTop = -parseFloat(_this.Defaults.popHeight) / 2 + popSizeUnit;

            //组装节点
            title.innerHTML = "输入验证码";
            title.appendChild(close);

            tip.innerHTML = "";
            callBackErrorTip.innerHTML = "";

            btn.innerHTML = "确定";
            btnWrap.appendChild(btn);

            wrap.appendChild(title);
            wrap.appendChild(tip);
            wrap.appendChild(callBackErrorTip);
            wrap.appendChild(pop);
            wrap.appendChild(btnWrap);

            outWrap.appendChild(wrap);
            outWrap.appendChild(mask);

            outWrap.style.display = "none";

            //关闭按钮
            close.onclick = function () {
                outWrap.style.display = "none";
            };

            //不重复添加复杂验证码弹层
            var outWrapExistLen = $(".js_configCaptchaPop").length;
            if (outWrapExistLen === 0) {
                document.body.appendChild(outWrap);
            }

        },
        //打开弹层
        openCaptchaPop: function (subfn, closefn) {   //打开弹层时，传入提交按钮函数和关闭按钮函数，不传：默认为一个空函数。
            var _this = this;
            _this.insertCaptchaHtmlFn($(".js_configCaptchaPop").find(".js_configCaptchaPopIn"), _this.Defaults.comHtml);//添加弹层中验证码元素

            _this.refreshCaptcha($(".js_configCaptchaPop")); //验证码初始化
            _this.callbackCaptchaErrorFn(false);  //恢复弹层默认提示语
            $(".js_configCaptchaPop").show();
            //弹层事件
            _this.addEventForCaptcha();
            //弹层提交执行函数
            if (typeof subfn === "function") {
                _this.popSubmit(subfn);
            } else {
                _this.popSubmit(_this.Defaults.subFn);
            }
            //关闭弹层执行函数
            if (typeof closefn === "function") {
                _this.closeCaptchaPopFn(closefn);
            } else {
                _this.closeCaptchaPopFn(_this.Defaults.closeFn);
            }

        },
         //打开腾讯云验证码弹层
         openTencentCaptchaPop:function(subfn){
            var _this = this;
            var captcha1 = new TencentCaptcha(_this.Defaults.tenyunAppId, function(res) {
                    if(res.ret === 0){
                        $("input[name=cookies]").remove();
                        $(_this.Defaults.captchaInWrap).append('<input type="hidden" name="cookies"  value="' + res.ticket + '"/>');
                        $("input[name=Captcha]").remove();
                        $(_this.Defaults.captchaInWrap).append('<input type="hidden" name="Captcha"  value="' + res.randstr + '"/>');
                        subfn();
                       
                    }
                });
            captcha1.show(); // 显示验证码
        },
        //关闭弹层
        closeCaptchaPop: function () {
            $(".js_configCaptchaPop").hide();
        },
        //关闭弹层执行函数
        closeCaptchaPopFn: function (fn) {
            $(".js_configCaptcha_close").unbind("click").bind("click", function () {
                $(".js_configCaptchaPop").hide();
                if (typeof fn === "function") {
                    fn();
                }
            });
        },
        //弹层提交
        popSubmit: function (fn) {
            var _this = this;
            //提交(如果验证码格式通过则提交)
            $(".js_chinaCaptchaBtn").unbind("click").bind("click", function () {
                if (_this.configCaptchaCheck($(_this.Defaults.captchaInWrap).find("input[name='" + _this.Defaults.inputName + "']"), $(".js_configCaptchaPop"))) {
                    fn(_this.Defaults);
                }
                return false;
            });
        },
        //给复杂验证码元素添加事件
        addEventForCaptcha: function () {
            var _this = this;
            var selectCaptchaWrapObj = null; //包含复杂验证码元素
            //选择验证码
            if (_this.Defaults.comIn) {

                selectCaptchaWrapObj = $(_this.Defaults.captchaInWrap);

                _this.refreshCaptcha(selectCaptchaWrapObj); //验证码初始化

            } else {

                selectCaptchaWrapObj = $(".js_configCaptchaPop");

            }


            selectCaptchaWrapObj.find(".js_captchaCaptchaSelect_img").unbind("click").bind("click", function () {
                _this.selectCaptcha($(this), selectCaptchaWrapObj);
                return false;
            });
            //删除验证码
            selectCaptchaWrapObj.find(".js_deleteConfigCaptcha").unbind("click").bind("click", function () {
                _this.deleteCaptcha(selectCaptchaWrapObj);
                return false;
            });

            //刷新验证码
            _this.refreshCaptchaEvent(selectCaptchaWrapObj);

        },
        //选择验证码
        selectCaptcha: function ($obj, wrap) {
            var _this = this;
            var
                obj = $obj,
                objAttrCode = obj.attr("data-code"),
                codeLen = parseInt($(_this.Defaults.captchaInWrap).find("input[name='" + _this.Defaults.inputName + "']").val().length),
                checkcodeStr = $(_this.Defaults.captchaInWrap).find("input[name='" + _this.Defaults.inputName + "']").val() + objAttrCode;

            if (codeLen < 4) {

                //验证码真实值
                $(_this.Defaults.captchaInWrap).find("input[name='" + _this.Defaults.inputName + "']").val(checkcodeStr);
                wrap.find(".js_configCaptchaInput").eq(codeLen).find("i").addClass("configCaptchaImg_" + objAttrCode);

            }
            this.configCaptchaCheck($(_this.Defaults.captchaInWrap).find("input[name='" + _this.Defaults.inputName + "']"), wrap);
        },
        //删除验证码
        deleteCaptcha: function (wrap) {
            var _this = this;
            var
                Len = parseInt($(_this.Defaults.captchaInWrap).find("input[name='" + _this.Defaults.inputName + "']").val().length),
                checkcodeStr1 = $(_this.Defaults.captchaInWrap).find("input[name='" + _this.Defaults.inputName + "']").val();

            checkcodeStr1 = checkcodeStr1.substring(0, Len - 1);
            $(_this.Defaults.captchaInWrap).find("input[name='" + _this.Defaults.inputName + "']").val(checkcodeStr1);


            var deleteObj = wrap.find(".js_configCaptchaInput").eq(Len - 1).find("i");
            var classNames = deleteObj[0].className;
            classNames = classNames.replace(/configCaptchaImg_[0-8]/g, "");
            deleteObj[0].className = classNames;


            this.configCaptchaCheck($(_this.Defaults.captchaInWrap).find("input[name='" + _this.Defaults.inputName + "']"), wrap);
        },
        //刷新验证码事件
        refreshCaptchaEvent: function (wrap) {
            var _this = this;
            wrap.find(".js_refreshConfigCaptcha").unbind("click").bind("click", function () {
                _this.refreshCaptcha(wrap);
                return false;
            });
        },
        //刷新验证码
        refreshCaptcha: function (wrap) {
            var _this = this;
            if (_this.captcahSwitchOpen != -1) {
                this.AjaxCookiesImgUrl(function (data) {
                    _this.createCaptchaUrl = data;
                    //获取域名提供同域
                    switch (_this.captcahSwitchOpen) {
                        case 0:
                            //获取中文验证码
                            wrap.find(".js_configCaptchaImg").attr("src", _this.createCaptchaUrl + "&r=" + Math.random());

                            break;
                        case 1:
                            //获取中文验证码

                            wrap.find(".js_configCaptchaImg").css("backgroundImage", "url(" + _this.createCaptchaUrl + "&r=" + Math.random() + ")");

                            wrap.find(".js_configCaptchaInput i").each(function () { //去掉选中复杂验证码class
                                var $this = $(this);
                                var classNames = $this[0].className;
                                classNames = classNames.replace(/configCaptchaImg_[0-8]/g, "");
                                $this[0].className = classNames;
                            });

                            $(_this.Defaults.captchaInWrap).find("input[name='" + _this.Defaults.inputName + "']").val(""); //清空弹层中隐藏域中的值

                            wrap.find(".js_checkChinaCaptchaTip").removeClass("success error"); //情况提示标识

                            break;
                        default:
                            break;
                    }
                })
            }
 },
        //接口返回验证码错误
        callbackCaptchaErrorFn: function (status) {
            var _this = this;
            if (status) {
                $(".js_errorTextTips").show().html(_this.Defaults.popErrorTip);
                $(".js_defaultTextTips").hide();
            } else {
                $(".js_errorTextTips").hide();
                $(".js_defaultTextTips").show().html(_this.Defaults.popDefaultTip);
            }

        },
        //验证验证码格式
        configCaptchaCheck: function (obj, wrap) {
            var _this = this;
            if (_this.VerCheckConfigCaptcha(obj, wrap) === true) {
                _this.VerConfigCaptchaOK(obj, wrap);
                return true;
            } else {
                return false;
            }
        },
        //验证复杂验证码格式
        VerCheckConfigCaptcha: function (obj, wrap) {
            var _this = this;
            var exp = new RegExp("^\\d{4}$");
            if (!exp.test(obj.val())) {
                _this.Defaults.errorTipFn(wrap);
                return false;
            } else {
                return true;
            }
        },
        //复杂验证码格式正确
        VerConfigCaptchaOK: function (obj, wrap) {
            var _this = this;
            _this.Defaults.succTipFn(wrap);
            return true;
        }
    };

    window.configCaptcha = function (obj) {
        return new ConfigCaptcha(obj);
    };
})();